export const transformDollarsToCents = (value: number | string) => {
  const valueString = value.toString().replace(/[^\d.-]/g, '')
  if (valueString && valueString.includes('.')) {
    return Math.round(parseFloat(valueString.substring(0, valueString.indexOf('.') + 3)) * 100)
  }
  return value ? Math.round(parseFloat(valueString) * 100) : 0
}
